import accounts_marketplace from 'i18n/adsimple/en/accounts_marketplace.yml'
import advertisers from 'i18n/adsimple/en/advertisers.yml'
import agency from 'i18n/adsimple/en/agency.yml'
import audits from 'i18n/adsimple/en/audits.yml'
import auth from 'i18n/adsimple/en/auth.yml'
import autoreplenish from 'i18n/adsimple/en/autoreplenish.yml'
import banners from 'i18n/adsimple/en/banners.yml'
import billing from 'i18n/adsimple/en/billing.yml'
import campaigns_editor from 'i18n/adsimple/en/campaigns_editor.yml'
import common from 'i18n/adsimple/en/common.yml'
import cookie_banner from 'i18n/adsimple/en/cookie-banner.yml'
import countries from 'i18n/adsimple/en/countries.yml'
import industries from 'i18n/adsimple/en/industries.yml'
import media_planner from 'i18n/adsimple/en/media_planner.yml'
import oauth from 'i18n/adsimple/en/oauth.yml'
import partners_program from 'i18n/adsimple/en/partners_program.yml'
import payment_order from 'i18n/adsimple/en/payment_order.yml'
import promised_payment from 'i18n/adsimple/en/promised_payment.yml'
import pulse from 'i18n/adsimple/en/pulse.yml'
import recommendations from 'i18n/adsimple/en/recommendations.yml'
import referral from 'i18n/adsimple/en/referral.yml'
import reward_calculator from 'i18n/adsimple/en/reward_calculator.yml'
import services from 'i18n/adsimple/en/services.yml'
import statistics from 'i18n/adsimple/en/statistics.yml'
import tickets from 'i18n/adsimple/en/tickets.yml'
import user from 'i18n/adsimple/en/user.yml'
import wallets from 'i18n/adsimple/en/wallets.yml'
import benchmarks from 'i18n/getuniq/en/benchmarks.yml'
import payment_profiles from 'i18n/adsimple/en/payment_profiles.yml'

export default {
  accounts_marketplace,
  advertisers,
  agency,
  audits,
  benchmarks,
  auth,
  autoreplenish,
  banners,
  billing,
  campaigns_editor,
  common,
  cookie_banner,
  countries,
  industries,
  media_planner,
  oauth,
  payment_profiles,
  partners_program,
  payment_order,
  promised_payment,
  pulse,
  recommendations,
  referral,
  reward_calculator,
  services,
  statistics,
  tickets,
  user,
  wallets,
}
